import { render, staticRenderFns } from "./digital-running-companion.vue?vue&type=template&id=79792d44"
import script from "./digital-running-companion.vue?vue&type=script&lang=ts"
export * from "./digital-running-companion.vue?vue&type=script&lang=ts"
import style0 from "./digital-running-companion.vue?vue&type=style&index=0&id=79792d44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports